import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 7.2,
		cy: 7.2,
		r: 6.45,
		stroke: "#141414",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.15 12.15L17.55 17.55",
		stroke: "#141414",
		strokeWidth: 1.5
	})]
});
export default SvgSearch;
